import { GoogleButtonType, GoogleButtonOption, SourceName } from 'social/publisher/Publisher.types';

export const GOOGLE_BUTTON_OPTIONS: GoogleButtonOption[] = [
    {
        value: GoogleButtonType.BOOK,
        label: 'BOOK',
        placeholder: 'http://www.example.com',
    },
    {
        value: GoogleButtonType.ORDER,
        label: 'ORDER_ONLINE',
        placeholder: 'http://www.example.com',
    },
    {
        value: GoogleButtonType.SHOP,
        label: 'SHOP',
        placeholder: 'http://www.example.com',
    },
    {
        value: GoogleButtonType.LEARN_MORE,
        label: 'LEARN_MORE',
        placeholder: 'http://www.example.com',
    },
    {
        value: GoogleButtonType.SIGN_UP,
        label: 'SIGN_UP',
        placeholder: 'http://www.example.com',
    },
    {
        value: GoogleButtonType.CALL,
        label: 'CALL',
        placeholder: 'YOUR_REGISTERED_GMB_PHONE_NUMBER',
    },
];

export const SOURCES: SourceName[] = ['FACEBOOK', 'TWITTER', 'INSTAGRAM', 'GOOGLE_PLACES', 'LINKEDIN'];
